<template>
  <div id="page-forms">
    <v-container fluid>
      <v-form
        v-model="form.valid"
        ref="mainform"
        lazy-validation
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            lg4
            sm4
          >
            <v-text-field
              label="Date"
              prepend-icon="date_range"
              v-model="form.date"
            ></v-text-field>
          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <!-- <div class="d-flex my-1"> -->
            <v-text-field
              label="User"
              prepend-icon="person"
              v-model="form.loginUser"
            ></v-text-field>
            <!-- </div> -->
          </v-flex>
          <v-flex
            lg4
            sm4
          >

            <v-autocomplete
              hint="Atleast 3 Characters required"
              chips             
              flat
              placeholder="Select only suggested Company"
              :items="companies"
              v-model="form.companyID"
              label="Company"
              auto
              chips
              prepend-icon="drag_indicator"
              color="blue"
              item-text="name"
              item-value="companyID"
            ></v-autocomplete>

          </v-flex>

          <v-flex
            lg4
            sm4
          >
            <v-autocomplete
              hint="Atleast 3 Characters required"              
              chips              
              flat
              placeholder="Select only suggested Department Owner"
              :items="users"
              v-model="form.deptOwner"
              label="Department Owner"
              auto
              chips
              prepend-icon="person"
              color="blue"
              item-text="userName"
              item-value="userID"
            ></v-autocomplete>

          </v-flex>

          <v-flex
            lg4
            sm4
          >

            <v-menu
              :close-on-content-click="false"
              v-model="menustart"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="form.startDate"
                label="Start Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="form.startDate"
                @input="menustart = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>

        </v-layout>
      </v-form>
    </v-container>
    <v-tabs color="transparent">
      <v-tabs-slider color="primary"></v-tabs-slider>

      <v-tab key="#tab-1">
        <v-card-title>Event</v-card-title>
      </v-tab>
      <v-tab key="#tab-2">
        <v-card-title>Production Schedule</v-card-title>
      </v-tab>
      <v-tab key="#tab-3">
        <v-card-title>Preparation</v-card-title>
      </v-tab>
      <v-tabs-items>
        <v-tab-item key="#tab-1">
          <v-card flat>
            <event ref="eventform"></event>
          </v-card>
        </v-tab-item>
        <v-tab-item key="#tab-2">
          <v-card flat>
            <!-- <production-schedule ref="prodeventform"></production-schedule> -->
          </v-card>
        </v-tab-item>
        <v-tab-item key="#tab-3">
          <v-card flat>
            <preparation ref="preparationform"></preparation>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>

  </div>
</template>
 
<script>
import Event from '@/pages/calendar/PPEvent';
import ProductionSchedule from '@/pages/calendar/PPProductionSchedule';
import Preparation from '@/pages/calendar/PPPreparation';

export default {
  components: {

    Event,
    ProductionSchedule,
    Preparation
  },

  data: () => ({

    companies: [
      { name: 'SWSG', companyID: 1 },
      { name: 'SWMY', companyID: 2 }
    ],
    users: [],
    menustart: false,
    loading: false,
    form: {

      valid: false,
      companyEventID: -1,
      companyID: null,
      deptOwner: null,
      loginUser: 'Arun',
      isLogin: 'yes-1',
      date: new Date().toISOString().substr(0, 10),
      eventTypeID: null,
      eventType: '',
      fullfilmentStatus: null,
      isEffectProdSchdule: null,
      authorityOrCompanyRequirement: '',
      name: '',
      notLaterDays: null,
      preparationDays: null,
      preparationTypeID: null,
      reminderby: null,
      repeatInfoID: null,
      requiredPreparation: null,
      standardFrequencyID: null,
      startDate: new Date().toISOString().substr(0, 10),
      taskContent: null,
      taskDueDate: new Date().toISOString().substr(0, 10),
      triggerDate: new Date().toISOString().substr(0, 10),
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
    }
  }),
  mounted () {
    this.$validator.localize('en', this.dictionary);
  },
  methods: {
    formateDate (string) {
      return string ? new Date(string).toLocaleDateString() : '';
    },
  }
};
</script> 


// WEBPACK FOOTER //
// src/pages/calendar/ProductionPlan.vue